import { ResourceExplorerChartData } from "../../../../services/cloudchipr.api";

export type ResourceExplorerChartDataSeriesTotalCostsMapType = Map<
  string,
  number
>;

export const aggregateResourceExplorerChartDataSeriesTotalCostsMap = (
  data: ResourceExplorerChartData[],
) => {
  return data.reduce((result, item, index) => {
    const key = index.toString();

    item?.items?.forEach((child) => {
      const total = result.get(key) ?? 0;
      if (child.field) {
        const itemCost = child?.cost ?? 0;
        const newValue = +(total + itemCost).toFixed(2);

        result.set(key, newValue);
      }
    });

    return result;
  }, new Map() as ResourceExplorerChartDataSeriesTotalCostsMapType);
};
